import { render } from "./EmployeeShowNoSalary.vue?vue&type=template&id=2b14f108"
import script from "./EmployeeShowNoSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeShowNoSalary.vue?vue&type=script&lang=js"

import "./EmployeeShowNoSalary.vue?vue&type=style&index=0&id=2b14f108&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__